import React from 'react';
import { HashRouter as Router } from 'react-router-dom';
import RentalFlow from './RentalFlow';

const RentalFlowWrapper = (props) => (
  <Router basename='/'>
    <RentalFlow {...props} />
  </Router>
);

export default RentalFlowWrapper;
